import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useQuery } from "@tanstack/react-query";

export function useGetOrganisationCrmList(org_id?: number) {
    return useQuery({
        ...queryKeys.crm.list._ctx.byOrgId(org_id!),
        enabled: !!org_id
    });
}